<script setup lang="ts">
import { useCurrentTime } from '@hooks/auth/use-current-time.hook'

import { AppText } from '@UI/Typography/AppText'

defineOptions({
  name: 'CurrentTime',
})

const {
  refDate,
  refTime,
} = useCurrentTime()
</script>

<template>
  <div class="time">
    <AppText name="body1">
      {{ refDate }}
    </AppText>
    <AppText name="body1">
      {{ refTime }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Auth/CurrentTime.scss" />
